import { Box } from '@chakra-ui/react';
import { AgGridReact } from 'ag-grid-react';

import type { NthCalculatorGridProps } from './types/nth-calculator-grid.props';

import { useNthCalculatorGridConfiguration } from './hooks/nth-calculator-grid-configuration';

const NthCalculatorGrid = ({
  dropBottom4Ref,
  getMailingListUpdatesRef,
  mailingId,
  nthThresholdPercentage,
  onOverThresholdChange,
  packageTarget,
  resetRef,
}: NthCalculatorGridProps) => {
  const {
    columns,
    context,
    defaultColumnDefinition,
    defaultGridOptions,
    getMailingListUpdates,
    handleDropBottom4,
    handleReset,
    isLoading,
    rowData,
    theme,
  } = useNthCalculatorGridConfiguration({ mailingId, nthThresholdPercentage, onOverThresholdChange, packageTarget });

  if (dropBottom4Ref) {
    dropBottom4Ref.current = handleDropBottom4;
  }

  if (resetRef) {
    resetRef.current = handleReset;
  }

  if (getMailingListUpdatesRef) {
    getMailingListUpdatesRef.current = getMailingListUpdates;
  }

  return (
    <Box
      h="full"
      w="full">
      <AgGridReact
        cellSelection={false}
        columnDefs={columns}
        context={context}
        defaultColDef={defaultColumnDefinition}
        gridOptions={defaultGridOptions}
        includeHiddenColumnsInQuickFilter={true}
        loading={isLoading}
        pagination={false}
        rowData={rowData}
        suppressContextMenu={true}
        theme={theme}
      />
    </Box>
  );
};

export default NthCalculatorGrid;
